export function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function dimensionContainer(value: number) {
  if (value >= 1280) {
    return 'xl';
  }
  if (value >= 960 && value <= 1279) {
    return 'md';
  }
  if (value >= 930 && value <= 959) {
    return 'md';
  }
  if (value >= 0 && value <= 929) {
    return 'md';
  }
  return 'xs';
}
